// @flow
import {contentScale, isIE, isEdge, isSafari} from '../environment.js';

export default function preprocess(text: string, baseUrl: string, stylePrefix: string, headingBaseLevel: number = 1) {
	let html = text
	.trim()

	.replace(/Ä/g, 'Ä')
	.replace(/Ö/g, 'Ö')
	.replace(/Ü/g, 'Ü')
	.replace(/ä/g, 'ä')
	.replace(/ö/g, 'ö')
	.replace(/ü/g, 'ü')

	//prefix image urls with image server baseurl
	.replace(
		/url\(['|"]?images\/([a-z0-9@_\/]+)?\.(png|jpg|gif|webp|avif)['|"]?\)/gi, (_, base, ext) =>
			`url(${baseUrl}images/${base}.${ext})`)

	// the first wbr in a paragraph can lead to some broken styling in different
	// browsers, so avoid that here
	.replace(/(<p[^>]*>\s*)<wbr>/g, '$1')

	// replace 3d rotations by 2d rotations, because 3d rotations force the whole
	// parent to be rasterized in low resolution, see #241
	.replace(/rotate3d\(0,\s*0,\s*1,\s*(-?[\d\.]+deg)\)/g, 'rotate($1)')

	//replace special characters that cause rendering issues in various browsers
	.replace(/\u0007/g, ''); //BEL character

	if (headingBaseLevel > 1) {
		//shift h1-h6 level based on baseLevel
		html = html.replace(/(<\/?)?h(\d)(#)?/g, (m, prefix = '', lvl, suffix = '') => {
			if (!prefix && !suffix) return m;
			const i = parseInt(lvl) + headingBaseLevel - 1
			return i > 6 ? `${prefix}div${suffix}` : `${prefix}h${i}${suffix}`
		})
	}

	if (stylePrefix) {    
		//prefix all ids
		html = html.replace(/((div|h\d)#[a-f0-9]{1,64})/g, stylePrefix + ' $1');
    	//prefix special link styling rules
		html = html.replace(
			/(([^,\n>](html\sbody)?((a|a:hover )?\[data-link-hover))|([^,\n>]*\[data\-pslnk))/gm,
			' ' + stylePrefix + ' .kent-page $1'
		);
	}

	if (isSafari || isIE || isEdge) {
		html = html
		// Safari & IE will ignore <wbr> as the last child of a <span>
		.replace(/<wbr>((<\/(span|b|i|strong|em|a)>)+)/g, '$1<x-wbr> </x-wbr>');
	}

	if (!IS_BROWSER) {
		//let's prevent scripts from happening in SSR
		html = html.replace(/<(\/?)script/g, '<$1x-scriptoid');
	}

	html = html
	// using CSS `content: " "` for wbr does not work in
	// firefox, so just create a hack element with a space context
	.replace(/<wbr>/g, '<x-wbr> </x-wbr>');

	return html;
}



// WEBPACK FOOTER //
// ./lib/pagehandler/preprocess.js